/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_Delete_FailedInputs */

const cs_settings_venues_delete_failed = /** @type {(inputs: Settings_Venues_Delete_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobočku se nepodařilo smazat.`)
};

const en_settings_venues_delete_failed = /** @type {(inputs: Settings_Venues_Delete_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The venue could not be deleted.`)
};

/**
* | output |
* | --- |
* | "The venue could not be deleted." |
*
* @param {Settings_Venues_Delete_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_delete_failed = /** @type {((inputs?: Settings_Venues_Delete_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_Delete_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_delete_failed(inputs)
	return cs_settings_venues_delete_failed(inputs)
});